import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8001";
const API = `${BACKEND_URL}/api`;

// Demo Capacity Monitoring. Deliberately unstyled and unlinked: reachable only
// by typing /admin, and it shows nothing at all unless the backend's
// ADMIN_USER_ID check passes for this session (a non-admin sees the same "Not
// found" the endpoint itself returns). Exists because the metrics endpoint
// can't be read by typing its URL -- only the app attaches a session token.
export default function AdminScreen() {
  const [metrics, setMetrics] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/demo-metrics`)
      .then((response) => setMetrics(response.data))
      .catch(() => setNotFound(true));
  }, []);

  if (notFound) return <div style={{ padding: 16, fontFamily: "system-ui" }}>Not found</div>;
  if (!metrics) return <div style={{ padding: 16, fontFamily: "system-ui" }}>Loading…</div>;

  const rows = [
    ["Active demo users", `${metrics.active_demo_users} / ${metrics.global_cap}`],
    ["Session length", `${metrics.session_hours}h`],
    ["Peak active, 24h", metrics.peak_active_24h],
    ["Peak active, 7d", metrics.peak_active_7d],
    ["Refused 24h — global cap", metrics.refusals_24h.global_cap],
    ["Refused 24h — per-IP limit", metrics.refusals_24h.per_ip_limit],
    ["Refused 24h — Turnstile", metrics.refusals_24h.turnstile],
    ["Refused 7d — global cap", metrics.refusals_7d.global_cap],
    ["Refused 7d — per-IP limit", metrics.refusals_7d.per_ip_limit],
    ["Refused 7d — Turnstile", metrics.refusals_7d.turnstile],
    ["Create-account clicks, 24h", metrics.conversion_clicks_24h],
    ["Create-account clicks, 7d", metrics.conversion_clicks_7d],
  ];

  return (
    <div style={{ padding: 16, fontFamily: "system-ui", maxWidth: 520 }} data-testid="admin-screen">
      <h1 style={{ fontSize: 18, marginBottom: 12 }}>Demo capacity</h1>
      <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 14 }}>
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label}>
              <td style={{ padding: "6px 8px 6px 0", borderBottom: "1px solid #ddd" }}>{label}</td>
              <td style={{ padding: "6px 0", borderBottom: "1px solid #ddd", textAlign: "right" }}>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ fontSize: 12, color: "#666", marginTop: 12 }}>
        Create-account clicks count demo visitors who clicked through to signup, not completed signups.
      </p>
    </div>
  );
}
